import { Location } from './location';
import { MilageAllowance } from './milageAllowance';
import { z } from 'zod';

export type Distance = z.infer<typeof Distance>;
export type DistanceUnit = z.infer<typeof DistanceUnit>;
export type DistanceVehicleType = z.infer<typeof DistanceVehicleType>;

export const DistanceUnit = z.enum(['km']);
export const DistanceVehicleType = z.enum(['car', 'motorcycle']);

export const Distance = z.object({
    locationFrom: Location.nullish(),
    locationTo: Location.nullish(),
    value: z.number().nullish(),
    rate: MilageAllowance.nullish().catch(() => null),
    unit: DistanceUnit.or(z.string() as z.ZodType<string & {}>).nullish(),
    vehicleType: DistanceVehicleType.or(z.string() as z.ZodType<string & {}>).nullish(),
});
